import { CatButton, CatHeading } from 'components/blocks-components';
import { useDealerLocatorModal } from 'components/dealer-locator/dealer-locator-modal-context';
import { useLoginUrl } from 'hooks/use-login-url';

type RegisterSignInButtonToastProps = {
  signInText: string;
  registerText: string;
  guestSaveText: string;
};
export const RegisterSignInButtonToast = ({
  guestSaveText,
  registerText,
  signInText
}: RegisterSignInButtonToastProps) => {
  const loginUrl = useLoginUrl();
  const dealerLocatorModal = useDealerLocatorModal();

  return (
    <div>
      <CatHeading variant="body-sm">{guestSaveText}</CatHeading>
      <div className="mt-2 ms-n3">
        <CatButton variant={'ghost'} size={'sm'} href={loginUrl}>
          <span className="text-capitalize">{signInText?.toLowerCase()}</span>
        </CatButton>
        <CatButton
          size={'sm'}
          onClick={() => dealerLocatorModal.modalControl.open()}
        >
          <span className="text-capitalize">{registerText}</span>
        </CatButton>
      </div>
    </div>
  );
};
